import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import EducationPage from './pages/EducationPage';
import TestimonialsPage from './pages/TestimonialsPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import VendorEmpanelmentPage from './pages/VendorEmpanelmentPage';
import BriquetteInfoPage from './pages/BriquetteInfoPage';
import BioCNGPlantPage from './pages/BioCNGPlantPage';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/briquette-info" element={<BriquetteInfoPage />} />
            <Route path="/bio-cng-plant" element={<BioCNGPlantPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/vendor-empanelment" element={<VendorEmpanelmentPage />} />
            <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#18181b',
              color: '#fafafa',
              border: '1px solid #27272a',
            },
            success: {
              iconTheme: {
                primary: '#a3e635',
                secondary: '#000',
              },
            },
          }}
        />
      </div>
    </CartProvider>
  );
}

export default App;
